import { T } from '@tribeplatform/react-components/i18n'

export type PlanCardButtonLabelVariant =
  | 'contact'
  | 'current'
  | 'downgrade'
  | 'downgrade-switch-monthly'
  | 'downgrade-switch-yearly'
  | 'subscribe'
  | 'switch-monthly'
  | 'switch-yearly'
  | 'upgrade'
  | 'upgrade-switch-monthly'
  | 'upgrade-switch-yearly'

interface Props {
  variant: PlanCardButtonLabelVariant
}

const multilineVariants: PlanCardButtonLabelVariant[] = [
  'downgrade-switch-monthly',
  'downgrade-switch-yearly',
  'switch-monthly',
  'switch-yearly',
  'upgrade-switch-monthly',
  'upgrade-switch-yearly',
]

export const PlanCardButtonLabel = ({ variant }: Props) => {
  const label = {
    contact: <T defaultMessage="Contact us" id="Generics.ContactUs" />,
    current: (
      <T defaultMessage="Current plan" id="Admin.Billing.Plans.CurrentPlan" />
    ),
    downgrade: (
      <T defaultMessage="Downgrade" id="Admin.Billing.Plans.DowngradeButton" />
    ),
    'downgrade-switch-monthly': (
      <T
        defaultMessage="Downgrade & switch to monthly"
        id="Admin.Billing.Plans.DowngradeAndSwitchToMonthlyBilling"
      />
    ),
    'downgrade-switch-yearly': (
      <T
        defaultMessage="Downgrade & switch to yearly"
        id="Admin.Billing.Plans.DowngradeSwitchToYearlyBilling"
      />
    ),
    subscribe: (
      <T defaultMessage="Subscribe now" id="Admin.Billing.Plans.SubscribeNow" />
    ),
    'switch-monthly': (
      <T
        defaultMessage="Switch to monthly billing"
        id="Admin.Billing.Plans.SwitchToMonthlyBilling"
      />
    ),
    'switch-yearly': (
      <T
        defaultMessage="Switch to yearly billing"
        id="Admin.Billing.Plans.SwitchToYearlyBilling"
      />
    ),
    upgrade: (
      <T defaultMessage="Upgrade" id="Admin.Billing.Plans.UpgradeButton" />
    ),
    'upgrade-switch-monthly': (
      <T
        defaultMessage="Upgrade & switch to monthly"
        id="Admin.Billing.Plans.UpgradeAndSwitchToMonthlyBilling"
      />
    ),
    'upgrade-switch-yearly': (
      <T
        defaultMessage="Upgrade & switch to yearly"
        id="Admin.Billing.Plans.UpgradeAndSwitchToYearlyBilling"
      />
    ),
  }[variant]

  if (multilineVariants.includes(variant)) {
    return <p className="text-sm whitespace-normal">{label}</p>
  }

  return label
}
